<template>
    <div class="qksm">
        <div class="nogap">
            <p><b>（四）2022年政府采购预算安排情况（包括专项资金和政府投资项目）</b></p>
            <p>
                2022年安排政府采购预算{{isMoney(T6.总计)}}万元。
            </p>
        </div>
    </div>
</template>
<script>
    export default {
        name: "qksm4",
        data() {
            return {
                isPdf: this.$parent.isPdf,
            }
        },
        props: {
            T6: {
                type: Object,
                default: "",
            },
        },
    };

</script>